export default __webpack_public_path__ + "static/media/nuestracartagena.ad0293ec.jpg";